module.exports = __webpack_public_path__ + "static/img/bot-step-6.293bbb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-6.png
// module id = pJHo
// module chunks = 11